import { Component } from '@angular/core';

import { SimulatorType } from '../../../core/enums/simulator-type.enum';
import { SimulatorConfig } from '../../../core/models/simulation.model';
import { BasicSimulatorComponent } from '../../../common/basic-simulator/basic-simulator.component';

@Component({
  selector: 'app-absolute-permeability',
  imports: [BasicSimulatorComponent],
  standalone: true,
  templateUrl: './absolute-permeability.component.html',
  styleUrl: './absolute-permeability.component.scss',
})
export class AbsolutePermeabilityComponent {
  readonly config: SimulatorConfig = {
    title: 'Subsample - Absolute Permeability Simulation',
    simulatorType: SimulatorType.SubsampleKabs,
  };
}
